import { useEffect } from "react";

import FormFieldViewText from "components/FormFields/ViewText";
import SpacePath from "components/SpacePath";
import TagsList from "components/TagsList";
import Box from "ds/components/Box";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import FormField from "ds/components/Form/Field";
import Typography from "ds/components/Typography";
import { TrackAnalyticsEventProperties } from "shared/Analytics";
import { AiIntegrationView } from "shared/AiIntegration/useSearchAiIntegrations/gql";

type AiIntegrationDetailsProps = {
  integration: AiIntegrationView;
  trackAnalytics: (event: string, props?: TrackAnalyticsEventProperties) => void;
};

const AiIntegrationDetailsDrawer = createDrawer(
  ({ integration, trackAnalytics }: AiIntegrationDetailsProps) => {
    useEffect(() => {
      trackAnalytics("Open Integration Details", { type: "ai" });
    }, [trackAnalytics]);

    return (
      <DrawerSimple>
        <DrawerHeader justify="between">
          <DrawerHeaderTitle title="Details" />
          <DrawerCloseIcon />
        </DrawerHeader>

        <DrawerBody>
          <FormFieldViewText label="Name" value={integration.name} />

          {integration.space && (
            <FormField label="Space">
              <SpacePath
                variant="expandable"
                spaceId={integration.space.id}
                fallbackName={integration.space.name}
              />
            </FormField>
          )}

          {integration.description && (
            <FormFieldViewText label="Description" value={integration.description} />
          )}

          <FormFieldViewText label="Provider" value={integration.provider} />

          <FormFieldViewText label="Status" value={integration.enabled ? "Enabled" : "Disabled"} />

          <FormField label="Models">
            <Box direction="column" gap="small">
              {integration.modelDetails.map((model) => (
                <Typography key={model.id} variant="p-body3" tag="span">
                  {model.name}
                </Typography>
              ))}
            </Box>
          </FormField>

          {integration.labels.length > 0 && (
            <FormField label="Labels">
              <TagsList tags={integration.labels} />
            </FormField>
          )}
        </DrawerBody>
      </DrawerSimple>
    );
  }
);

export const showAiIntegrationDetailsDrawer = createDrawerTrigger(AiIntegrationDetailsDrawer);
